/**
 * Accounts admin handler
 * Manages enterprise tenant accounts
 */

import { useCallback } from "react";
import type { accountTypes } from "@pineseed/spec";
import { useBaseEntityAdmin, type EntityAdminHandler } from "../useEntityAdmin";
import type { UseAdminAppReturn } from "../useAdminApp";

type Account = accountTypes["Account"];

export interface AccountsAdminHandler extends EntityAdminHandler<Account> {
  // Account-specific operations can be added here
  getStats: () => {
    total: number;
  };
}

export function useAccountsAdmin(adminApp: UseAdminAppReturn): AccountsAdminHandler {
  // Base CRUD operations
  const baseHandler = useBaseEntityAdmin<Account>({
    adminApp,
    endpoint: 'accounts',
    entityName: 'account',
    crudEndpoint: 'account',
    workspaceScoped: false,
  });

  // Get statistics
  const getStats = useCallback(() => {
    return {
      total: baseHandler.entities.length,
    };
  }, [baseHandler.entities]);

  return {
    ...baseHandler,
    getStats,
  };
}

